// components/dashboard/ScoreChart.jsx
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { useTranslation } from "react-i18next"; // ← اضافه شده

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const ScoreChart = ({ exams = [] }) => {
  const { t } = useTranslation(); // ← اضافه شده

  const labels = exams.map((exam, i) => exam.title || t('score_chart.exam_label', { count: i + 1 }));
  const scores = exams.map((exam) => exam.percentage || 0);

  const average =
    scores.length > 0
      ? (scores.reduce((sum, s) => sum + s, 0) / scores.length).toFixed(1)
      : 0;

  const isMobile = window.innerWidth < 640;

  const data = {
    labels,
    datasets: [
      {
        label: t('score_chart.score_label'),
        data: scores,
        backgroundColor: "#6366f1",
        borderRadius: 0,
        barThickness: isMobile ? 20 : 35,
        maxBarThickness: 50,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw}%`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        ticks: {
          callback: (value) => `${value}%`,
        },
        title: {
          display: true,
          text: t('score_chart.y_axis_title'),
        },
      },
      x: {
        title: {
          display: true,
          text: t('score_chart.x_axis_title'),
        },
      },
    },
  };

  return (
    <div className="bg-white p-5 rounded-xl shadow">
      <h3 className="text-lg font-semibold text-gray-700 mb-1">
        {t('score_chart.last_10_exams_title')}
      </h3>
      <p className="text-sm text-gray-500 mb-4">
        {t('score_chart.average_score')}:{" "}
        <span className="font-semibold text-gray-700">{average}%</span>
      </p>
      <Bar data={data} options={options} />
    </div>
  );
};

export default ScoreChart;